<template lang="pug">
form.padding
  .form-group
    select.form-control
      option Tous les membres de vos groupes
      option Dans ton cuivre
    .row
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric
      .col-sm-4.col-md-3(style="cursor: pointer")
        .checkbox
          label(style="width: 100%;")
            input(type='checkbox')
            |  Pluquet Frédéric        
</template>
<script type="text/javascript">
export default {
}
</script>



// WEBPACK FOOTER //
// SelectMembers.vue?1b05bacd